"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Label = exports.TinyLoader = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var loader_1 = __importDefault(require("../loader"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
exports.TinyLoader = function () { return (react_1["default"].createElement("span", { style: { display: 'inline-block' } },
    react_1["default"].createElement(loader_1["default"], { size: 20 }))); };
exports.Label = function (props) {
    var isLoading = props.isLoading, label = props.label;
    if (!isLoading) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, label);
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(exports.TinyLoader, null),
        " \u00A0\u00A0",
        label,
        ' '));
};
var MyButton = function (props) {
    var label = props.label, target = props.target, onClick = props.onClick, className = props.className, _a = props.primary, primary = _a === void 0 ? false : _a, _b = props.loading, loading = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, type = props.type, style = props.style;
    var history = react_router_dom_1.useHistory();
    var color = props.color ? props.color : primary ? 'primary' : 'default';
    var disabledFinal = loading || disabled;
    var handleClick = function () {
        if (onClick) {
            return onClick();
        }
        if (target) {
            history.push(target);
            return;
        }
    };
    return (react_1["default"].createElement(Button_1["default"], { className: className, variant: "contained", color: color, disabled: disabledFinal, onClick: handleClick, type: type, style: style },
        react_1["default"].createElement(exports.Label, { label: label, isLoading: loading })));
};
exports["default"] = MyButton;
